import * as React from "react";
const SvgFiRrChannel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.5 9.5a2.5 2.5 0 0 0-2.289 1.5h-3.353a4 4 0 0 0-.987-1.774l1.747-2.853a2.498 2.498 0 0 0 1.648-4.607 2.5 2.5 0 0 0-3.354 3.562l-1.753 2.863a4 4 0 0 0-1.16-.192c-.406 0-.79.079-1.16.192L9.086 5.328a2.5 2.5 0 1 0-4.18-.124A2.5 2.5 0 0 0 7.38 6.373l1.747 2.853A4 4 0 0 0 8.14 11H4.787A2.498 2.498 0 0 0 0 12a2.5 2.5 0 0 0 4.789 1h3.353c.176.677.515 1.286.987 1.774l-1.747 2.853a2.5 2.5 0 1 0 1.705 1.045l1.753-2.863c.369.113.753.192 1.159.192s.79-.079 1.159-.192l1.754 2.864a2.497 2.497 0 0 0 3.354 3.562 2.5 2.5 0 0 0-1.648-4.607l-1.747-2.853a4 4 0 0 0 .987-1.774h3.353a2.498 2.498 0 0 0 4.789-1 2.5 2.5 0 0 0-2.5-2.5zM10 12c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2"
    />
  </svg>
);
export default SvgFiRrChannel;
